// import { BM_MODE } from '@/env';

import { rtkQueryApi } from './rtk-query-api';

type ConfigRequest = string[];
type ConfigResponse = Record<string, string>;

export const otherApi = rtkQueryApi
  .enhanceEndpoints({ addTagTypes: ['UserFinance'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getMoscowDateTime: builder.query<{ datetime: string }, any>({
        query: () => 'seo/get-moscow-date-time',
      }),
      getConfig: builder.query<ConfigResponse, ConfigRequest>({
        query: (names) => ({
          url: '/user/get-config',
          method: 'post',
          body: {
            names,
          },
        }),
        providesTags: ['UserFinance'],
      }),
      saveConfig: builder.mutation<any, { items: Record<string, any> }>({
        query: ({ items }) => ({
          url: '/user/save-config',
          method: 'POST',
          body: { items },
        }),
        invalidatesTags: ['UserFinance'],
      }),
    }),
  });

export const {
  useLazyGetMoscowDateTimeQuery,
  useGetMoscowDateTimeQuery,
  useLazyGetConfigQuery,
  useGetConfigQuery,
  useSaveConfigMutation,
} = otherApi;
